/**
 * Русское склонение при числе: «1 команда», «2 команды», «5 команд».
 *
 * Без этого в интерфейсе появляется «2 команд» — мелочь, которая читается
 * как небрежность на каждом экране, где есть счётчик.
 */
export function plural(count: number, one: string, few: string, many: string): string {
  const abs = Math.abs(count) % 100;
  const last = abs % 10;
  if (abs > 10 && abs < 20) return many;
  if (last > 1 && last < 5) return few;
  if (last === 1) return one;
  return many;
}

/** Число вместе со словом: `withCount(2, 'команда', 'команды', 'команд')`. */
export function withCount(count: number, one: string, few: string, many: string): string {
  return `${count} ${plural(count, one, few, many)}`;
}
